import type { SiteScopeParams } from '@wix/thunderbolt-symbols'
import { InvalidJsonError } from '@wix/thunderbolt-commons'

/**
 * Parses and validates the appDefinitionIdToSiteRevision param.
 * Accepts a string (may be empty/undefined), returns a Record<string, string>.
 * Throws InvalidJsonError if not a valid object with string keys and string values.
 */
export const parseAndValidateAppDefinitionIdToSiteRevision = (
	appDefinitionIdToSiteRevision?: string
): SiteScopeParams['appDefinitionIdToSiteRevision'] => {
	if (!appDefinitionIdToSiteRevision) {
		return {}
	}
	try {
		const parsed = JSON.parse(appDefinitionIdToSiteRevision)
		if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
			throw new Error('Parsed value is not an object')
		}
		for (const [key, value] of Object.entries(parsed)) {
			if (typeof key !== 'string' || typeof value !== 'string') {
				throw new Error(
					`Invalid entry in appDefinitionIdToSiteRevision: key=${JSON.stringify(key)}, value=${JSON.stringify(
						value
					)}`
				)
			}
		}
		return parsed
	} catch (error) {
		throw new InvalidJsonError('appDefinitionIdToSiteRevision', error)
	}
}
